import React, { Component, PropTypes } from 'react';
import omit from 'lodash.omit';
import isNewTabEvent from 'is-new-tab-event';

const noop = () => {};

const once = fn => {
  let hasRun = false;

  return () => {
    if (hasRun) {
      return;
    }

    hasRun = true;
    fn();
  };
};

export default class InterceptedLink extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    href: PropTypes.string.isRequired,
    intercept: PropTypes.arrayOf(PropTypes.func),
    interceptTimeout: PropTypes.number,
    onClick: (props, propName, componentName) => {
      const propValue = props[propName];

      if (typeof propValue !== 'undefined') {
        return new Error(`Use 'intercept' instead of 'onClick' in ${componentName}.`);
      }
      return null;
    }
  };

  static defaultProps = {
    intercept: [],
    interceptTimeout: 1000
  };

  constructor() {
    super();

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    const { intercept, interceptTimeout, href } = this.props;

    let promises;

    try {
      promises = intercept.map(fn => fn && fn());
    } catch (err) {
      return;
    }

    if (!promises.some(promise => promise && promise.then)) {
      return;
    }

    if (isNewTabEvent(event)) {
      Promise.all(promises).then(noop, noop); // Without .then() there is an error in Chrome (when Promise is native): Uncaught (in promise) undefined
    } else {
      event.preventDefault();

      const navigate = once(() => {
        window.location.href = href;
      });

      setTimeout(navigate, interceptTimeout);

      Promise.all(promises).then(navigate, navigate);
    }
  }

  render() {
    const { children, href, ...restProps } = this.props;

    return (
      <a
        {...omit(restProps, 'intercept', 'interceptTimeout', 'dispatch')}
        href={href}
        onClick={this.onClick}>
        {children}
      </a>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/wip_modules/react-intercepted-link/index.js
 **/